import { LocaleKey } from 'translations';

/**
 * Strips array indices from RJSF field names.
 * RJSF generates field IDs like "arrayName_0_fieldName" for array items.
 * This normalizes them to just "fieldName" for translation key lookup.
 *
 * Examples:
 * - "relinings_0_lining" -> "lining"
 * - "relinings_2_preparations_preparationType" -> "preparations_preparationType"
 * - "items_0_name" -> "name"
 * - "regularField" -> "regularField" (unchanged)
 */
export function normalizeFieldName(fieldName: string): string {
  // Match pattern: wordChars_digits_ at the start of the string or after another such pattern
  // This strips RJSF array index prefixes like "relinings_0_", "items_1_", etc.
  return fieldName.replace(/^(\w+_\d+_)+/g, '');
}

export function composeTranslationKey(...args: string[]): LocaleKey {
  /**
   * TODO: Add check with error for the translation key existence
   * */
  const key = args.join('.');
  return key as LocaleKey;
}
